export const _LOAD_MODEL_ = 'Load:Rating';
export const _SAVE_MODEL_ = 'Save:Rating';

export const MODEL_QUESTION_TYPE = [
  { value: 'int', text: 'Número (0-5)' },
  { value: 'boolean', text: 'Sim/Não' },
  { value: 'string', text: 'Texto' },
];

export const MODEL_QUESTION = {
  id: null,
  type: 'int',
  order: null,
  question: null,
  rating_id: null,
};

export const MODEL_ANSWER = {
  id: null,
  type: null,
  value: null,
  question_id: null,
};

export const MODEL_RATING = {
  id: null,
  name: null,
  slug: null,
  questions: [{ ...MODEL_QUESTION }],
};
